// password-forgot.actions.ts

import { createActionGroup, emptyProps, props } from '@ngrx/store';

/**
 * Password Recovery Request Actions
 * Handles sending password reset emails
 */
export const passwordRecoveryRequestActions = createActionGroup({
  source: 'Password Recovery/Request',
  events: {
    Create: props<{ email: string }>(),
    'Create Success': props<{ email: string }>(),
    'Create Failure': props<{ error: any }>(),
  },
});

/**
 * Password Recovery Confirmation Actions
 * Handles confirming password reset with secret token
 */
export const passwordRecoveryConfirmActions = createActionGroup({
  source: 'Password Recovery/Confirm',
  events: {
    Confirm: props<{ email: string; sc: string; password: string }>(),
    'Confirm Success': emptyProps(),
    'Confirm Failure': props<{ error: any }>(),
  },
});
